// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__dMmtI","errors":"Errors_errors__GUJ5J"};